import { useState, useRef, useMemo } from 'react';
import { tabs as tabsModel } from '../constants/tabs';

export const useTabsInicio = ({  estadosRI, handleChangeFilters, initialActiveTabEnum }) => {
    const debounceRef = useRef(null);
    const [tabs, setTabs] = useState(tabsModel.map(tab => ({
        ...tab,
        active: tab.enumName === initialActiveTabEnum
    })));

    const activeTabId = useMemo(() => { return tabs.find(tab => tab.active)?.id }, [tabs]);
    const activeTabEnum = useMemo(() => { return tabs.find(tab => tab.active)?.enumName }, [tabs]);

    const estadoPendienteRI = estadosRI.find(x => x.displayName === 'Pendiente')?.id;

    const handleClickTab = (id, runQuery) => {
        const currentTab = tabs.find(tab => tab.active);
        if (currentTab.id === id) return;

        if (debounceRef.current) clearTimeout(debounceRef.current);

        const updatedTabs = tabs.map(tab => ({ ...tab, active: tab.id === id }));
        setTabs(updatedTabs);

        const selectedTab = updatedTabs.find(tab => tab.id === id);
        const defaultState = selectedTab.enumName === 'ASIGNACION' ? -1 : estadoPendienteRI;
        handleChangeFilters('activeTabEnum', selectedTab.enumName);
        handleChangeFilters('estado', defaultState);
        // setEstado(defaultState);

        debounceRef.current = setTimeout(() => {
            // runQuery(); se cambió a un useEffect en el componente padre
        }, 300);
    }

    return {
        tabs,
        setTabs,
        activeTabId,
        activeTabEnum,
        handleClickTab,
    };
};